import axios from 'axios';

const MAX_RETRIES = 3;

/**
 * Whether a failed CorePass Connector QR request is worth sending again.
 *
 * Nothing in the 4xx range is retried. The connector refuses a second QR request while an order for
 * the same user is still in flight, and the request it already accepted expires 5-15 minutes later,
 * so retrying a rejection cannot succeed — it only spends the window the user has left to scan.
 * This covers the 400 that carries the missing-fields list, which reaches us as a 400 rather than a
 * 422 because the connector route has no `api/v2` segment for FrontOffice to key its API version on.
 */
export const shouldRetryKycRequest = (failureCount: number, error: unknown): boolean => {
  if (axios.isCancel(error)) {
    return false;
  }

  const status = (error as { response?: { status?: number } })?.response?.status;

  if (typeof status === 'number' && status >= 400 && status < 500) {
    return false;
  }

  return failureCount < MAX_RETRIES;
};
